console.log('mobile Active');
$('body').addClass('mobile');
let adminPanel = $('#links_admin');
let tafel = $('#rechts_admin');
let adminPanelInner = adminPanel.find('#admin_eingabe_innen');
let isOpen = false;

window.mobileAdminpanel = {
    vars:{
        adminPanel: $('#links_admin'),
        tafel: $('#rechts_admin'),
        adminPanelInner: adminPanel.find('#admin_eingabe_innen'),
        isOpen: false
    },
    ele:{
        overlay: $('<div class="overlay"></div>'),
        popUop: $('<div class="popup"></div>'),
        close: $('<div class="closepanel">close</div>')
    },
    initMobilePanel: function () {
        this.ele.overlay = $('<div class="overlay"></div>');
        this.ele.popUop = $('<div class="popup"></div>');
        this.ele.close= $('<div class="closepanel">schließen</div>');
        this.vars.adminPanel.hide();
        let close = this.ele.close;
        let thiz = this;
        // $('div[class^=\"zelle\"]').on('click',function () {
        //     mobileAdminpanel.openMobilePanel();
        //     console.log('zellen klick');
        // });

        this.ele.close.on('click',function () {
            thiz.closeMobilePanel();
        });
    },
    generatepopUp:function () {

    },
    openMobilePanel:function () {
        this.vars.adminPanel.hide();
        $('body').css({
            'overflow':'hidden'
        });
        if($.contains(document, this.ele.overlay[0])){
            this.ele.overlay.show();
        } else {
            $('.mobile').append(this.ele.overlay);
            $('.overlay').append(this.ele.close);
        }

        var adminpanel = $('#admin_eingabe_innen form').clone();
        adminpanel.addClass('mobileadminform');
        $('.mobile').append(adminpanel);

    },
    closeMobilePanel:function(){
        this.ele.overlay.hide();
        $('.mobile .mobileadminform').remove();
        $('body').css({
            'overflow':'inherit'
        });
    }
};
mobileAdminpanel.initMobilePanel();
tafel.css({
    'margin-left': 0
});

adminPanel.find('table').css({
    'max-width':$(window).width() -20,
    'width':$(window).width() -20,
    'max-height':$(window).height() -100,
    'height':$(window).height() -100,
    'margin':0,
    'padding':0,
    'box-sizing':'border-box',
    'overflow': 'scroll'
});

var toggleSwitch = $('<div class="toggleAdmin">\n    <i class="material-icons">settings</i>\n    <span>Adminpanel </span>\n</div>');
// adminPanel.prepend(toggleSwitch);

// adminPanelInner.hide();

toggleSwitch.click(function () {
    mobileAdminpanel.initMobilePanel();
    console.log('touch');
    adminPanel.find('#admin_eingabe_innen').toggle();
});


// WEBPACK FOOTER //
// ./js/mobile_state.js